import {useCallback, useEffect, useRef, useState} from "react";

import {BOTTOM_SHEET_CLOSE_MS, BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS} from "../constants/bottom_sheet";

interface IOptions {
    closeMs?: number;
    toggleDebounceMs?: number;
    onOpen?: () => void;
}

export const useBottomSheetState = (options: IOptions = {}) => {
    const {closeMs = BOTTOM_SHEET_CLOSE_MS, toggleDebounceMs = BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS, onOpen} = options;

    const [isOpen, setIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isEntering, setIsEntering] = useState(false);

    const lastToggleAtRef = useRef(0);
    const isOpenRef = useRef(isOpen);
    const isClosingRef = useRef(isClosing);
    const onOpenRef = useRef(onOpen);

    isOpenRef.current = isOpen;
    isClosingRef.current = isClosing;
    onOpenRef.current = onOpen;

    const close = useCallback(() => {
        if (!isOpenRef.current || isClosingRef.current) return;

        setIsEntering(false);
        setIsClosing(true);
    }, []);

    const open = useCallback(() => {
        setIsClosing(false);
        setIsEntering(true);
        setIsOpen(true);
        onOpenRef.current?.();
    }, []);

    const toggle = useCallback(() => {
        const now = Date.now();
        if (now - lastToggleAtRef.current < toggleDebounceMs) return;
        lastToggleAtRef.current = now;

        if (isClosingRef.current) {
            setIsClosing(false);
            setIsEntering(false);
            return;
        }

        if (isOpenRef.current) return close();

        open();
    }, [close, open, toggleDebounceMs]);

    useEffect(() => {
        if (!isOpen || !isEntering || isClosing) return;

        const timeoutId = window.setTimeout(() => setIsEntering(false), closeMs);
        return () => window.clearTimeout(timeoutId);
    }, [closeMs, isClosing, isEntering, isOpen]);

    useEffect(() => {
        if (!isClosing) return;

        const timeoutId = window.setTimeout(() => {
            setIsOpen(false);
            setIsClosing(false);
            setIsEntering(false);
        }, closeMs);

        return () => window.clearTimeout(timeoutId);
    }, [closeMs, isClosing]);

    useEffect(() => {
        if (!isOpen && !isClosing) return;

        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") close();
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [close, isClosing, isOpen]);

    return {
        close,
        isClosing,
        isEntering,
        isOpen,
        open,
        toggle
    };
};
import {useCallback, useEffect, useRef, useState} from "react";

import {BOTTOM_SHEET_CLOSE_MS, BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS} from "../constants/bottom_sheet";

interface IOptions {
    closeMs?: number;
    toggleDebounceMs?: number;
    onOpen?: () => void;
}

export const useBottomSheetState = (options: IOptions = {}) => {
    const {closeMs = BOTTOM_SHEET_CLOSE_MS, toggleDebounceMs = BOTTOM_SHEET_TOGGLE_DEBOUNCE_MS, onOpen} = options;

    const [isOpen, setIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isEntering, setIsEntering] = useState(false);

    const lastToggleAtRef = useRef(0);
    const isOpenRef = useRef(isOpen);
    const isClosingRef = useRef(isClosing);
    const onOpenRef = useRef(onOpen);

    isOpenRef.current = isOpen;
    isClosingRef.current = isClosing;
    onOpenRef.current = onOpen;

    const close = useCallback(() => {
        if (!isOpenRef.current || isClosingRef.current) return;

        setIsEntering(false);
        setIsClosing(true);
    }, []);

    const open = useCallback(() => {
        setIsClosing(false);
        setIsEntering(true);
        setIsOpen(true);
        onOpenRef.current?.();
    }, []);

    const toggle = useCallback(() => {
        const now = Date.now();
        if (now - lastToggleAtRef.current < toggleDebounceMs) return;
        lastToggleAtRef.current = now;

        if (isClosingRef.current) {
            setIsClosing(false);
            setIsEntering(false);
            return;
        }

        if (isOpenRef.current) return close();

        open();
    }, [close, open, toggleDebounceMs]);

    useEffect(() => {
        if (!isOpen || !isEntering || isClosing) return;

        const timeoutId = window.setTimeout(() => setIsEntering(false), closeMs);
        return () => window.clearTimeout(timeoutId);
    }, [closeMs, isClosing, isEntering, isOpen]);

    useEffect(() => {
        if (!isClosing) return;

        const timeoutId = window.setTimeout(() => {
            setIsOpen(false);
            setIsClosing(false);
            setIsEntering(false);
        }, closeMs);

        return () => window.clearTimeout(timeoutId);
    }, [closeMs, isClosing]);

    useEffect(() => {
        if (!isOpen && !isClosing) return;

        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") close();
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [close, isClosing, isOpen]);

    return {
        close,
        isClosing,
        isEntering,
        isOpen,
        open,
        toggle
    };
};
